import { singleton } from 'tsyringe';

@singleton()
export class BrowserService {
    get 是微信浏览器(): boolean {
        return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) !== null;
    }
}
